import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-page-wr"
}
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "subtitle-main" }
const _hoisted_4 = { class: "filters" }
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = { class: "table-default" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = { class: "status-body" }
const _hoisted_10 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "title-main" }, "Customers", -1)),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(`${$setup.companies.length} customer${$setup.companies.length > 1 ? "s" : ""}`), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["InputSearch"], {
            modelValue: $setup.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
            placeholder: "Search",
            theme: "filter"
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            class: "button default primary add-btn-primary",
            onClick: $setup.toCreateUser
          }, "Add Customer")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Company"),
                _createElementVNode("th", null, "Administrator"),
                _createElementVNode("th", null, "Email"),
                _createElementVNode("th", null, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.companies, (company) => {
                return (_openBlock(), _createElementBlock("tr", {
                  onClick: ($event: any) => ($setup.toCompany(company.detailsId))
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(company.companyName), 1),
                  _createElementVNode("td", null, _toDisplayString(company.adminName), 1),
                  _createElementVNode("td", null, _toDisplayString(company.adminEmail), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(company.status), 1)
                ], 8, _hoisted_7))
              }), 256))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10))
}